<template>
  <div class="contenedor-login">
    <div class="login">
      <svg
        class="logo"
        width="266"
        height="63"
        viewBox="0 0 266 63"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <rect width="266" height="63" fill="url(#pattern0)" />
        <defs>
          <pattern
            id="pattern0"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              xlink:href="#image0_2602:12967"
              transform="translate(0 -0.00094162) scale(0.00338983 0.0143126)"
            />
          </pattern>
          <image
            id="image0_2602:12967"
            width="295"
            height="70"
            xlink:href="data:image/png;base64,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"
          />
        </defs>
      </svg>
      <span class="datos-accesso">Configura tu contraseña</span>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="verificarCorreo">
          <div class="campo">
            <span class="etiqueta-campo"> Contraseña </span>
            <validation-provider
              v-slot="{ errors }"
              name="pass"
              rules="required|min:8|customPassword"
            >
              <v-text-field
                outlined
                single-line
                v-model="pass"
                :value="pass"
                :error-messages="errors"
                :append-icon="verContrasena ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (verContrasena = !verContrasena)"
                :type="verContrasena ? 'password' : 'text'"
              ></v-text-field>
            </validation-provider>
          </div>
          <div class="campo">
            <span class="etiqueta-campo"> Confirma contraseña </span>
            <validation-provider
              v-slot="{ errors }"
              name="confirmationPassword"
              rules="required|confirmed:pass"
            >
              <v-text-field
                single-line
                v-model="confirmationPass"
                :error-messages="errors"
                outlined
                append-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </validation-provider>
          </div>
          <v-btn
            v-bind:class="[invalid ? 'btn-bloqueado' : 'btn-ingresar']"
            text
            :loading="cargando"
            large
            rounded
            type="submit"
            :disabled="invalid"
          >
            guardar y continuar
          </v-btn>
        </form>
      </validation-observer>
    </div>
    <div class="imagen">
      <svg
        width="287"
        height="287"
        viewBox="0 0 287 287"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M137.335 6.16504C61.4869 6.16504 0 67.652 0 143.5C0 158.833 2.51517 173.579 7.15146 187.349L192.703 269.207C240.973 247.915 274.67 199.647 274.67 143.5C274.67 67.652 213.183 6.16504 137.335 6.16504Z"
          fill="#4C2783"
        />
        <path
          d="M190.632 162.102L121.028 103.813C120.509 103.378 120.013 102.931 119.553 102.512C105.182 89.4281 100.795 69.5057 107.01 52.2319H71.9725C64.964 52.2319 59.2616 46.5295 59.2616 39.5204C59.2616 38.7597 59.3328 38.0153 59.4611 37.2905H26.2953C15.4879 37.2905 6.72656 46.0519 6.72656 56.8592V186.04C10.6358 198.049 16.155 209.331 23.0284 219.632L88.2575 271.801C103.498 277.635 120.042 280.835 137.335 280.835C157.169 280.835 176.017 276.623 193.044 269.057C193.056 268.787 193.065 268.518 193.065 268.245V162.988C192.201 162.988 191.337 162.693 190.632 162.102Z"
          fill="#384051"
        />
        <path
          d="M51.3853 37.291H26.2953C15.4879 37.291 6.72656 46.0524 6.72656 56.8597V186.041C10.6358 198.05 16.155 209.332 23.0284 219.633L51.3853 242.312V52.807C41.2675 45.0086 51.3853 37.291 51.3853 37.291Z"
          fill="#2D3243"
        />
        <path
          d="M103.152 11.8677H96.6395C88.1057 11.8677 81.1235 18.8498 81.1235 27.3836H118.668C118.668 18.8498 111.686 11.8677 103.152 11.8677Z"
          fill="#ED9E30"
        />
        <path
          d="M100.031 13.0061C100.903 12.5628 101.814 12.1866 102.751 11.8677H96.6389C88.1051 11.8677 81.1229 18.8498 81.1229 27.3836H99.1686C94.3939 24.1313 93.8827 16.1306 100.031 13.0061Z"
          fill="#FDCA00"
        />
        <path
          d="M177.549 267.965V151.146L121.028 103.813C120.509 103.378 120.013 102.931 119.553 102.512C105.341 89.5723 100.896 69.9459 106.811 52.8066H26.5756C24.1826 52.8066 22.2426 54.7467 22.2426 57.1397V218.444C38.2109 242.917 61.7684 261.983 89.5805 272.299H173.216C175.609 272.298 177.549 270.358 177.549 267.965Z"
          fill="#F7F3F1"
        />
        <path
          d="M47.0524 57.1392C47.0524 54.7462 48.9925 52.8062 51.3854 52.8062H26.5756C24.1827 52.8062 22.2432 54.7462 22.2432 57.1392V218.443C29.1738 229.065 37.5354 238.666 47.053 246.978V57.1392H47.0524Z"
          fill="#CDE2FF"
        />
        <path
          d="M115.204 38.5531C119.357 33.5945 124.329 29.72 129.758 26.9531C129.124 26.8595 128.477 26.8091 127.819 26.8091H71.972C64.6647 26.8091 58.6859 32.7879 58.6859 40.0952C58.6859 47.4024 64.6647 53.3812 71.972 53.3812H106.811C108.628 48.1155 111.411 43.0823 115.204 38.5531Z"
          fill="#FDCA00"
        />
        <path
          d="M127.819 26.8091H86.8411C94.1484 26.8091 100.127 32.7879 100.127 40.0952C100.127 47.4024 94.1484 53.3812 86.8411 53.3812H106.811C108.628 48.116 111.412 43.0823 115.204 38.5531C119.357 33.5945 124.329 29.72 129.758 26.9531C129.124 26.8595 128.477 26.8091 127.819 26.8091Z"
          fill="#FEAC00"
        />
        <path
          d="M85.716 76.6554H81.3258C75.1469 76.6554 70.1199 71.6285 70.1199 65.4495V52.2324C70.1199 49.8518 72.0493 47.9224 74.4299 47.9224C76.8106 47.9224 78.74 49.8518 78.74 52.2324V65.4495C78.74 66.8515 79.9238 68.0354 81.3258 68.0354H85.716C86.0747 68.0354 86.4251 67.8408 86.6543 67.514C88.7553 64.5157 92.1836 62.7253 95.8254 62.7253H103.967C105.707 62.7253 107.446 63.1395 108.995 63.9237C111.119 64.9977 111.971 67.5903 110.896 69.7148C109.822 71.8392 107.228 72.6901 105.105 71.6156C104.75 71.4362 104.367 71.3454 103.967 71.3454H95.8254C94.9925 71.3454 94.2032 71.7624 93.7139 72.4609C91.8719 75.0876 88.8825 76.6554 85.716 76.6554Z"
          fill="#FDCA00"
        />
        <path
          d="M92.4033 73.9719C92.8843 73.5173 93.3254 73.0145 93.7133 72.4607C94.2027 71.7622 94.9925 71.3452 95.8249 71.3452H103.966C104.367 71.3452 104.75 71.436 105.105 71.6154C107.228 72.6899 109.822 71.839 110.896 69.7146C111.97 67.5906 111.119 64.9976 108.995 63.9235C107.445 63.1388 105.706 62.7251 103.966 62.7251H95.8249C92.1836 62.7251 88.7547 64.5155 86.6538 67.5138C87.7906 68.6506 92.4033 67.9539 92.4033 73.9719Z"
          fill="#FDCA00"
        />
        <path
          d="M65.2297 93.4722H52.0125C48.2199 93.4722 45.1167 96.5754 45.1167 100.368V113.585C45.1167 117.378 48.2199 120.481 52.0125 120.481H65.2297C69.0223 120.481 72.1255 117.378 72.1255 113.585V100.368C72.1255 96.5748 69.0223 93.4722 65.2297 93.4722Z"
          fill="white"
        />
        <path
          d="M56.0048 114.333L48.3152 106.644C46.6319 104.961 46.6319 102.232 48.3146 100.549C49.9985 98.8654 52.7272 98.866 54.4094 100.549L59.0519 105.191L71.3817 92.8603C73.065 91.1781 75.7937 91.1781 77.4771 92.8603C79.1604 94.5436 79.1604 97.2723 77.4771 98.9557L62.0996 114.334C60.4163 116.015 57.6875 116.016 56.0048 114.333Z"
          fill="#9E88BE"
        />
        <path
          d="M99.2885 103.311H94.9208C92.5401 103.311 90.6107 101.381 90.6107 99.0005C90.6107 96.6198 92.5401 94.6904 94.9208 94.6904H99.2885C101.669 94.6904 103.599 96.6198 103.599 99.0005C103.599 101.381 101.669 103.311 99.2885 103.311Z"
          fill="white"
        />
        <path
          d="M114.516 119.263H94.9208C92.5401 119.263 90.6107 117.334 90.6107 114.953C90.6107 112.572 92.5401 110.643 94.9208 110.643H114.516C116.897 110.643 118.826 112.572 118.826 114.953C118.826 117.334 116.897 119.263 114.516 119.263Z"
          fill="white"
        />
        <path
          d="M65.2297 136.134H52.0125C48.2199 136.134 45.1167 139.237 45.1167 143.03V156.247C45.1167 160.039 48.2199 163.143 52.0125 163.143H65.2297C69.0223 163.143 72.1255 160.039 72.1255 156.247V143.03C72.1255 139.236 69.0223 136.134 65.2297 136.134Z"
          fill="white"
        />
        <path
          d="M56.0048 156.994L48.3152 149.305C46.6319 147.622 46.6319 144.893 48.3146 143.21C49.9985 141.526 52.7272 141.527 54.4094 143.209L59.0519 147.851L71.3817 135.521C73.065 133.838 75.7937 133.838 77.4771 135.521C79.1604 137.204 79.1604 139.933 77.4771 141.616L62.0996 156.994C60.4163 158.677 57.6875 158.678 56.0048 156.994Z"
          fill="#9E88BE"
        />
        <path
          d="M146.448 145.972H94.9208C92.5401 145.972 90.6107 144.043 90.6107 141.662C90.6107 139.281 92.5401 137.352 94.9208 137.352H146.448C148.829 137.352 150.759 139.281 150.759 141.662C150.758 144.043 148.829 145.972 146.448 145.972Z"
          fill="white"
        />
        <path
          d="M134.476 161.924H94.9208C92.5401 161.924 90.6107 159.994 90.6107 157.614C90.6107 155.233 92.5401 153.304 94.9208 153.304H134.476C136.857 153.304 138.786 155.233 138.786 157.614C138.786 159.994 136.857 161.924 134.476 161.924Z"
          fill="white"
        />
        <path
          d="M65.2297 178.795H52.0125C48.2199 178.795 45.1167 181.899 45.1167 185.691V198.908C45.1167 202.701 48.2199 205.804 52.0125 205.804H65.2297C69.0223 205.804 72.1255 202.701 72.1255 198.908V185.691C72.1255 181.899 69.0223 178.795 65.2297 178.795Z"
          fill="#CDE2FF"
        />
        <path
          d="M151.62 188.634H94.9208C92.5401 188.634 90.6107 186.704 90.6107 184.324C90.6107 181.943 92.5401 180.014 94.9208 180.014H151.62C154.001 180.014 155.93 181.943 155.93 184.324C155.93 186.704 154.001 188.634 151.62 188.634Z"
          fill="white"
        />
        <path
          d="M134.476 204.586H94.9208C92.5401 204.586 90.6107 202.657 90.6107 200.276C90.6107 197.895 92.5401 195.966 94.9208 195.966H134.476C136.857 195.966 138.786 197.895 138.786 200.276C138.786 202.657 136.857 204.586 134.476 204.586Z"
          fill="white"
        />
        <path
          d="M65.2297 221.457H52.0125C48.2199 221.457 45.1167 224.56 45.1167 228.353V241.57C45.1167 245.363 48.2199 248.466 52.0125 248.466H65.2297C69.0223 248.466 72.1255 245.363 72.1255 241.57V228.353C72.1255 224.56 69.0223 221.457 65.2297 221.457Z"
          fill="#CDE2FF"
        />
        <path
          d="M58.6208 198.908V185.691C58.6208 181.947 61.6467 178.881 65.3732 178.803C65.325 178.802 65.2779 178.795 65.2297 178.795H52.0125C48.2199 178.795 45.1167 181.899 45.1167 185.691V198.908C45.1167 202.701 48.2199 205.804 52.0125 205.804H65.2297C65.2779 205.804 65.325 205.798 65.3732 205.797C61.6467 205.719 58.6208 202.653 58.6208 198.908Z"
          fill="#AAD1F7"
        />
        <path
          d="M58.6208 241.57V228.353C58.6208 224.608 61.6467 221.542 65.3732 221.464C65.325 221.463 65.2779 221.457 65.2297 221.457H52.0125C48.2199 221.457 45.1167 224.56 45.1167 228.353V241.57C45.1167 245.363 48.2199 248.466 52.0125 248.466H65.2297C65.2779 248.466 65.325 248.46 65.3732 248.459C61.6467 248.381 58.6208 245.314 58.6208 241.57Z"
          fill="#AAD1F7"
        />
        <path
          d="M151.62 231.295H94.9208C92.5401 231.295 90.6107 229.365 90.6107 226.985C90.6107 224.604 92.5401 222.675 94.9208 222.675H151.62C154.001 222.675 155.93 224.604 155.93 226.985C155.93 229.365 154.001 231.295 151.62 231.295Z"
          fill="white"
        />
        <path
          d="M134.476 247.248H94.9208C92.5401 247.248 90.6107 245.318 90.6107 242.938C90.6107 240.557 92.5401 238.627 94.9208 238.627H134.476C136.857 238.627 138.786 240.557 138.786 242.938C138.786 245.318 136.857 247.248 134.476 247.248Z"
          fill="white"
        />
        <path
          d="M271.547 37.0672C254.611 16.8427 224.486 13.587 204.261 30.5239L198.949 34.9719C195.361 37.977 190.134 37.977 186.545 34.9719L181.233 30.5239C161.009 13.587 130.884 16.8427 113.947 37.0666C97.4427 56.7743 99.5593 85.8785 118.392 103.024C118.886 103.474 119.383 103.921 119.9 104.354L189.75 162.849C191.485 164.302 194.01 164.302 195.744 162.849L265.594 104.354C266.111 103.921 266.608 103.474 267.102 103.024C285.934 85.8785 288.052 56.7749 271.547 37.0672Z"
          fill="#E5646E"
        />
        <path
          d="M153.428 88.4447C152.995 87.9279 152.584 87.401 152.177 86.8718C136.648 66.6849 139.675 37.662 159.384 21.1584C159.658 20.9285 159.941 20.7167 160.219 20.4941C143.57 17.2491 125.625 23.1231 113.947 37.0673C97.4432 56.775 99.5604 85.8786 118.393 103.025C118.886 103.475 119.384 103.921 119.9 104.354L189.751 162.85C191.485 164.302 194.011 164.302 195.745 162.85L207.493 153.011L153.428 88.4447Z"
          fill="#E15762"
        />
        <path
          d="M194.008 125.645C192.169 125.645 190.523 124.475 189.928 122.721L179.193 91.1056H169.554L160.979 112.855C160.305 114.563 158.633 115.661 156.788 115.58C154.953 115.503 153.368 114.271 152.841 112.512L142.536 78.1508L138.847 88.272C138.247 89.9195 136.708 91.0394 134.955 91.1033L102.804 92.2754C100.414 92.3556 98.4264 90.503 98.3396 88.1251C98.2532 85.7462 100.111 83.7478 102.49 83.6609L131.742 82.5942L138.884 62.9964C139.52 61.2514 141.217 60.1219 143.059 60.1639C144.915 60.2178 146.529 61.4554 147.062 63.2341L157.524 98.1186L162.611 85.2153C163.26 83.569 164.851 82.486 166.62 82.486H182.28C184.127 82.486 185.768 83.6621 186.361 85.4104L193.334 105.947L207.259 49.013C207.723 47.1167 209.404 45.7691 211.355 45.7282C211.386 45.7276 211.416 45.7271 211.447 45.7271C213.361 45.7271 215.05 46.9922 215.586 48.8381L225.33 82.4855H232.67L238.841 68.4735C239.521 66.9281 241.041 65.923 242.729 65.9011C244.406 65.8647 245.962 66.8445 246.683 68.3715L253.342 82.4855H282.689C285.07 82.4855 286.999 84.4149 286.999 86.7955C286.999 89.1762 285.07 91.1056 282.689 91.1056H250.61C248.942 91.1056 247.423 90.1431 246.712 88.6347L242.92 80.5976L239.426 88.5321C238.737 90.096 237.189 91.105 235.481 91.105H222.091C220.173 91.105 218.486 89.8365 217.952 87.994L211.797 66.742L198.194 122.359C197.739 124.22 196.11 125.557 194.196 125.641C194.134 125.644 194.07 125.645 194.008 125.645Z"
          fill="#F7F3F1"
        />
        <path
          d="M239.149 149.675C218.483 178.297 207.493 177.076 207.493 217.375C207.493 236.131 217.28 243.91 227.745 246.87C255.436 222.636 273.3 187.456 274.591 148.08C265.041 139.638 251.145 133.061 239.149 149.675Z"
          fill="#674796"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { required, confirmed, min } from "vee-validate/dist/rules";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { validarHash, verficarCorreo } from "../../services/usuarios/usuarios";
let errorMessage;
extend("customPassword", {
  message: () => errorMessage,
  validate: (value) => {
    const notTheseChars = /["'?&/<>\s]/;
    const mustContainTheseChars =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#!@$%^*-]).{8,}$/;
    const containsForbiddenChars = notTheseChars.test(value);
    const containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars && !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        errorMessage =
          'La contraseña no puede contener los siguentes caracteres: " ' +
          " ' ? & / < > o espacio";
      } else {
        errorMessage =
          "La contraseña debe contener al menos una letra mayúscula, una minúscula, un número y un caracter especial ($@$!%*#?&)";
      }
      return false;
    }
  },
});

extend("required", {
  ...required,
  message: "Campo requerido",
});

extend("min", {
  ...min,
  message: "La contraseña debe tener mínimo 8 caracteres",
});

extend("confirmed", {
  ...confirmed,
  message: "La contraseña no coincide",
});

export default {
  name: "Login",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      pass: null,
      verContrasena: true,
      confirmationPass: null,
      cargando: false,
    };
  },
  methods: {
    verificarCorreo() {
      this.cargando = true;
      verficarCorreo(this, {
        pass: this.pass,
        hash: this.$route.params.uuid,
      }).then(() => {
        this.cargando = false;
        this.$router.push({
          name: "Login",
          params: { correoVerificado: true },
        });
      });
    },
  },
  created() {
    validarHash(this, this.$route.params.uuid)
      .then(() => {
        localStorage.removeItem("token");
        this.$store.commit("setUsuario", {
          rol: null,
          nombres: null,
          token: null,
          validar: true,
        });
      })
      .catch((err) => {
        if (err.status === 403) this.$router.push({ name: "Login" });
      });
  },
};
</script>

<style scoped>
body {
  background-image: none;
}

.bienvenido {
  font-size: 24px;
  margin-bottom: 1em;
  font-weight: normal;
}
.btn-ingresar {
  font-weight: 600;
  background: #842e7c;
  color: white !important;
  width: 403px;
}

.btn-bloqueado {
  background: #b4b4b4;
  color: white !important;
  width: 403px;
}
.campo {
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 400px;
}

.campo i {
  color: #842e7c !important;
}

.contenedor-icono-error {
  width: 45px;
  height: 45px;
  background-color: #cf3e3e;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contenedor-login {
  display: grid;
  grid-template-columns: 56% 44%;
}
.contenido-mensaje {
  margin: 0 1.5em;
  display: flex;
  align-items: center;
  gap: 1em;
}

.datos-accesso {
  text-transform: uppercase;
  position: relative;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 2em;
}

.datos-accesso:before {
  content: "";
  position: absolute;
  width: 80px;
  left: -85px;
  top: 12px;
  border-top: 1px solid black;
  height: 1px;
}

.datos-accesso:after {
  content: "";
  position: absolute;
  width: 80px;
  right: -85px;
  top: 12px;
  border-top: 1px solid black;
  height: 1px;
}

.icono {
  color: white;
}

.imagen {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: linear-gradient(158.2deg, #842e7c -8.7%, #9e88be 105.2%);
}

.mensaje {
  width: 400px;
  height: 80px;
  background-color: #f0ebf8;
  border-radius: 6px;
  margin-bottom: 2em;
  display: flex;
  align-items: center;
}

.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fcfaff;
}

.logo {
  margin-bottom: 2.5em;
}
</style>